import React, { FC } from 'react';
import cls from 'classnames';

import { ButtonIconProps, ButtonIconVariant } from './ButtonIcon.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import { ColorClassnames } from '../../../../../tailwind/src/theme';


export const classNames = getClassNames('sds-button-icon', [
	'is-enabled',
	'variant-tertiary',
	'variant-secondary',
	'variant-outline',
	'variant-inverse-tertiary',
	'variant-inverse-secondary',
	'variant-inverse-outline',
	'variant-primary',
	'variant-dim',
	'variant-brighten',
	'variant-highlight',
	'size-standard',
	'size-small',
	'size-logo',
]);

const variantToTokenMap: { [key in ButtonIconVariant]: ColorClassnames } = {
	'primary': "text-onPrimaryFixedVariant",
	'secondary': "text-onSurfaceVariant",
	'tertiary': "text-secondary",
	'outline': "text-secondary",
	'brighten': "text-backgroundFixedWhite",
	'highlight': 'text-onSurface',
	'dim': "text-backgroundFixedBlack",
	'inverseSecondary': "text-inverseOnSurface",
	'inverseTertiary': "text-inverseOnSurface",
	'inverseOutline': "text-inverseOnSurface",
};

const ButtonIcon: FC<ButtonIconProps> = (props) => {
	const {
		isEnabled = true,
		variant = 'tertiary',
		altText,
		size = 'standard',
		Icon,
		label,
	} = props;

	return (
		<button
			className={cls(getRootClassListFromProps(classNames, props))}
			disabled={!isEnabled}
			onClick={props.onClick}
			type="button"
			title={altText}
			aria-label={label}
		>
			<Icon size={size === 'small' ? '2XS' : 'XS'}
			color={variantToTokenMap[variant]} 
			/>
		</button>
	);
};

ButtonIcon.defaultProps = {};

ButtonIcon.displayName = 'ButtonIcon';

export default ButtonIcon;
